export default __webpack_public_path__ + "static/b-card-mobile first-61811d5d39f97f297394559857cad6e6.jpg";